import React from "react";

import { ReactComponent as HushBorderSVG } from "src/images/svg/hush-border.svg";

import "./hush-border.css";

export const HushBorder = ({ className }: { className?: string }) => {
	return <HushBorderSVG className={className} />;
};
